module.exports = __webpack_public_path__ + "static/img/free_bg.4d6b61b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/free_bg.png
// module id = vm88
// module chunks = 1